var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TemplateBasic',{attrs:{"breadcrumb":_vm.breadcrumb,"permission":_vm.permission}},[_c('h2',{staticStyle:{"padding":"100px"}},[_vm._v("\n    Welcome to ParkBills\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5794c854","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page/PageLanding.vue
// module id = null
// module chunks = 